// announcement-bar.js — StateDecal
// Rotating messages + sessionStorage dismiss

(function () {
  'use strict';

  var DISMISSED_KEY = 'sd_ann_dismissed';
  var bar = document.getElementById('announcement-bar');
  if (!bar) return;

  // Hide immediately if previously dismissed
  if (sessionStorage.getItem(DISMISSED_KEY)) {
    bar.classList.add('announcement-bar--dismissed');
    return;
  }

  // Dismiss button handler
  var dismissBtn = bar.querySelector('.announcement-bar__dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', function () {
      bar.classList.add('announcement-bar--dismissed');
      sessionStorage.setItem(DISMISSED_KEY, '1');
    });
  }

  // Message rotation
  var messages = bar.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;

  var interval = parseInt(bar.dataset.interval, 10) || 5000;
  var current = 0;

  setInterval(function () {
    var next = (current + 1) % messages.length;

    messages[current].classList.remove('announcement-bar__message--active');
    messages[current].setAttribute('aria-hidden', 'true');

    messages[next].classList.add('announcement-bar__message--active');
    messages[next].setAttribute('aria-hidden', 'false');

    current = next;
  }, interval);
})();
